import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Divider } from '@mui/material';
import Crown from '@/assets/crown';
import CustomLinkModal from './CustomLinkModal.js';
import useDialogs from '@/hooks/useDialogs';
import { useEvent, useCustomLinksActions } from '@/store';

export default function CustomLinkBanner() {
  const { t } = useTranslation();
  const { openModal } = useDialogs();
  const {
    customLink: { hasCustomLink, linkStatus },
  } = useCustomLinksActions();

  const {
    event: { event },
  } = useEvent();

  useEffect(() => {
    if (hasCustomLink) {
      openModal(CustomLinkModal, {
        name: event.name,
        maxTickets: event.max_tickets_per_booking,
      });
    }
  }, []);

  return (
    <>
      {hasCustomLink && (
        <Box
          sx={{
            borderRadius: '10px',
            background: (theme) => theme.palette.common.white,
            boxShadow:
              '0px 0px 2px 0px rgba(145, 158, 171, 0.20), 0px 0px 24px -4px rgba(145, 158, 171, 0.10)',
            display: 'flex',
            alignItems: 'center',
            p: 1.5,
            mb: 1,
          }}
        >
          <Crown sx={{ width: '36px', height: '36px', mr: 1 }} />
          <Divider orientation="vertical" flexItem />
          <Box sx={{ flexGrow: 1, ml: 1 }}>
            <Typography component="span" variant="body2">
              <Typography
                component="span"
                variant="body2"
                sx={{
                  fontWeight: 600,
                  background:
                    'linear-gradient(270deg, #D55DB8 73.78%, #3D49CC 100%)',
                  backgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                {t('checkout.customLinks.exclusiveAccess')}
              </Typography>{' '}
              {t('checkout.customLinks.bannerText', {
                qty: event.max_tickets_per_booking,
              })}
            </Typography>
          </Box>
        </Box>
      )}
    </>
  );
}
